<template>
  <div>
    <Intro />
  </div>
</template>

<script>
import Intro from '@/components/Record/Intro'
export default {
  name: 'RecordView',
  components: {
    Intro
  }
}
</script>
